module.exports = __webpack_public_path__ + "static/media/lan-deng-quddu_dZKkQ-unsplash.0be4616f.jpg";